import angular from 'angular'
import statisticsTaxRateCtrl from './statisticsTaxRateCtrl'
import { statisticsTaxRate } from 'redevConfig'
const list = (statisticsTaxRate && statisticsTaxRate.list) || ''
const detail = (statisticsTaxRate && statisticsTaxRate.detail) || ''

const statisticsTaxRateList = list ? require(`redevelopment/statistics/statisticsTaxRate/${list.templateName}`) : require('./view/statisticsTaxRateList.html')
const statisticsTaxRateListCtrl = list ? require(`redevelopment/statistics/statisticsTaxRate/${list.controllerName}`) : require('./statisticsTaxRateListCtrl')

const statisticsTaxRateDetail = detail ? require(`redevelopment/statistics/statisticsTaxRate/${detail.templateName}`) : require('./view/relatedBill_invoice.html')
const statisticsTaxRateDetailCtrl = detail ? require(`redevelopment/statistics/statisticsTaxRate/${detail.controllerName}`) : require('./statisticsTaxRateDetailCtrl')


export default angular
    .module('app.statisticsTaxRate', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('statistics.outputStatistics.statisticsTaxRate', {
                abstract: true,
                url: '/statisticsTaxRate',
                template: '<div ui-view></div>',
                // controller: 'statisticsTaxRateCtrl',
                title: '税率统计',
                default: 'statistics.outputStatistics.statisticsTaxRate.list',
            })
            .state('statistics.outputStatistics.statisticsTaxRate.list', {
                url: '/list',
                template: statisticsTaxRateList,
                controller: 'statisticsTaxRateListCtrl',
            })
            .state('statistics.outputStatistics.statisticsTaxRate.detail', {
                url: '/detail/:param',
                template: statisticsTaxRateDetail,
                controller: 'statisticsTaxRateDetailCtrl',
                title: '统计详情',
            })
    }])
    .controller('statisticsTaxRateCtrl', statisticsTaxRateCtrl)
    .controller('statisticsTaxRateListCtrl', statisticsTaxRateListCtrl.default)
    .controller('statisticsTaxRateDetailCtrl', statisticsTaxRateDetailCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsTaxRate/index.js